<template>
    <DCard
        padding
    >
        <Form
            :available-permissions="availablePermissions"
            :available-tenants="availableTenants"
            :selected-tenants="selectedTenants"
            :selected-permissions="selectedPermissions"
            :errors="errors"
            @saveRole="saveRole"
        />
    </DCard>
</template>

<script>
import Form from '~@/Components/Settings/Roles/Form'

export default {
    name: 'RoleCreate',
    components: { Form },
    props: {
        availablePermissions: {
            type: Array,
            default: () => { return [] }
        },
        errors: {
            type: Object,
            default: () => { return {} }
        },
        availableTenants: {
            type: Array,
            default: () => { return [] }
        },
        selectedTenants: {
            type: Array,
            default: () => { return [] }
        },
        selectedPermissions: {
            type: Array,
            default: () => { return [] }
        }
    },
    methods: {
        saveRole (data) {
            this.$inertia.post(this.$route('settings.roles.store'), data)
        }
    }
}
</script>

<style scoped>

</style>
